import { render, staticRenderFns } from "./InstallationAndDeliveryDetailsAndForm.vue?vue&type=template&id=1d1b5766&scoped=true"
import script from "./InstallationAndDeliveryDetailsAndForm.vue?vue&type=script&lang=ts"
export * from "./InstallationAndDeliveryDetailsAndForm.vue?vue&type=script&lang=ts"
import style0 from "./InstallationAndDeliveryDetailsAndForm.vue?vue&type=style&index=0&id=1d1b5766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1b5766",
  null
  
)

export default component.exports